import { api } from "@/lib/api";

/** Upload an image or video file to Cloudinary using a signed backend signature.
 *  Returns {secure_url, public_id, resource_type} on success. */
export async function uploadToCloudinary(file, folder = "uploads", resourceType) {
  const isVideo = resourceType === "video" || (file.type && file.type.startsWith("video/"));
  const rt = isVideo ? "video" : "image";
  // 1. Get signature from backend
  const { data: sig } = await api.get("/uploads/signature", {
    params: { folder, resource_type: rt },
  });

  // 2. Upload directly to Cloudinary
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${sig.cloud_name}/${rt}/upload`,
    { method: "POST", body: form }
  );
  if (!res.ok) {
    const t = await res.text();
    throw new Error(`Upload failed: ${t}`);
  }
  const json = await res.json();
  // Build a proper Cloudinary video poster (frame at 2s, delivered as JPG)
  let thumbnail_url = json.secure_url;
  if (isVideo) {
    thumbnail_url = json.secure_url
      .replace("/upload/", "/upload/so_2,f_jpg,q_auto/")
      .replace(/\.[^/.]+$/, ".jpg");
  }
  return { secure_url: json.secure_url, public_id: json.public_id, resource_type: rt, thumbnail_url };
}
